/**
 * Capitalizes first word of string
 * @param {string} s
 */
export const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Truncate string at given length 
 * @param {string} s 
 * @param {number} maxLength 
 */
export const truncateString = (s, maxLength = 50) => {
	if (!s) return null;
	if (s.length <= maxLength) return s;
	return `${s.substring(0, maxLength)}...`;
};

/**
 * Sanitize urls
 * @param {string} param 
 * @returns {string} sanitized url param
 */
export const urlFriendlyParam = (param = '') => {
	return param.trim()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[)(/,."-]/g, '')
		.replace(/\s+/g, '-')
		.toLowerCase();
};